import type { SiteAnnouncement } from '@lambda/shared/types';

function announcementSignature(a: SiteAnnouncement): string {
  return [
    a.announcementId,
    a.title,
    a.message,
    a.iconType,
    a.endDate,
    a.showOnLandingPage ? '1' : '0',
    String(a.createdAt),
  ].join('\u001f');
}

/** True when two announcement lists would render the same dashboard/landing banners. */
export function siteAnnouncementsEqual(
  a: SiteAnnouncement[],
  b: SiteAnnouncement[]
): boolean {
  if (a.length !== b.length) return false;
  const left = [...a].sort((x, y) => x.announcementId.localeCompare(y.announcementId));
  const right = [...b].sort((x, y) => x.announcementId.localeCompare(y.announcementId));
  return left.every((item, index) => announcementSignature(item) === announcementSignature(right[index]));
}
